// hooks/useTimeline.ts -  Timeline interaction logic
import { useRef } from 'react';

export const useTimeline = () => {
  const timelineRef = useRef<HTMLDivElement>(null);

  /**
   * Handle timeline click to seek to a specific time
   */
  const handleTimelineClick = (
    event: React.MouseEvent<HTMLDivElement>,
    duration: number,
    onSeek: (time: number) => void
  ) => {
    if (!timelineRef.current) return;
    
    const rect = timelineRef.current.getBoundingClientRect();
    const clickPosition = (event.clientX - rect.left) / rect.width;
    const newTime = clickPosition * duration;
    
    onSeek(newTime);
  };

  /**
   * Calculate timeline position as percentage for a given time
   */
  const getTimelinePosition = (time: number, duration: number): string => {
    return `${(time / duration) * 100}%`;
  };

  /**
   * Calculate time from timeline position (0-1)
   */
  const getTimeFromPosition = (position: number, duration: number): number => {
    return position * duration;
  };

  return {
    timelineRef,
    handleTimelineClick,
    getTimelinePosition,
    getTimeFromPosition
  };
};